/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendSpreadsheetConfigDto } from '../../models/backend-spreadsheet-config-dto';
import { BackendSpreadsheetConfigRequestDto } from '../../models/backend-spreadsheet-config-request-dto';

export interface SalesSpreadsheetUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body: BackendSpreadsheetConfigRequestDto;
}

export function salesSpreadsheetUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: SalesSpreadsheetUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendSpreadsheetConfigDto>> {
  const rb = new RequestBuilder(rootUrl, salesSpreadsheetUpdate$XWwwFormUrlencoded.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendSpreadsheetConfigDto>;
    }),
  );
}

salesSpreadsheetUpdate$XWwwFormUrlencoded.PATH = '/api/sales/spreadsheet/{id}';
